import React, { useContext } from 'react';
import { __RouterContext } from 'react-router';
import { Link as ReactRouterLink } from 'react-router-dom';

import NextLink from '@scale/frontend-lib/link';

interface IsomorphicLinkProps {
  href: any;
  rel?: string;
  target?: string;
  className?: string;
  style?: React.CSSProperties;
  'data-for'?: string;
  'data-tip'?: string;
  onClick?: () => void;
  children?: React.ReactNode;
}

/*
  this component allows you to link
  - react-router => react-router pages
  - next.js => next.js pages
  - next.js => react-router pages (will do a full page reload)
  but will not work for react-router => next.js transitions, use an <a href=""> for that
*/
const IsomorphicLink: React.FC<IsomorphicLinkProps> = ({
  href,
  rel,
  target,
  className,
  children,
  style,
  onClick,
  ...props
}) => {
  const usingReactRouter = useContext(__RouterContext);
  const isInOutlier = window.location.pathname.includes('/outlieradmin');
  const isInRemo = window.location.pathname.includes('/remoadmin');

  // If we are in a react-router context, we use react-router link
  if (usingReactRouter && !isInOutlier && !isInRemo) {
    return (
      <ReactRouterLink
        className={className}
        onClick={onClick}
        to={href}
        target={target}
        style={style}
        data-for={props['data-for']}
        data-tip={props['data-tip']}
      >
        {children}
      </ReactRouterLink>
    );
  }

  // We are inside next.js scope, we use next.js link
  return (
    <NextLink href={href}>
      <a
        className={className}
        target={target}
        rel={rel}
        style={style}
        data-for={props['data-for']}
        data-tip={props['data-tip']}
      >
        {children}
      </a>
    </NextLink>
  );
};

export default IsomorphicLink;
